export enum PageTypes {
    HOME = "Home",
    PDP = "PDP",
    PCP = "PCP",
    PLP = "PLP",
    SEARCH = "Search",
    ACCOUNT = "My Account",
    EDITORIAL = "Editorial",
    ORDER_TRACKING = "Order Tracking",
    ERROR = "Error",
    AUTHORIZATION = "Authorization",
    SHOPPING_BAG = "Shopping Bag",
    CHECKOUT = "Checkout",
    ORDER_CONFIRMATION = "Order Confirmation",
    STORE_LOCATOR = "Store Locator",
    CUSTOMER_SERVICE = "Customer Service",
    GENERIC = "Generic",
    ACCOUNT_EMAIL_VERIFICATION = "Account Email Verification",
    TWO_COLUMNS = "pageTwoColumns",
}
